import { render, staticRenderFns } from "./PaginacaoLista.vue?vue&type=template&id=e241123e&scoped=true&"
import script from "./PaginacaoLista.vue?vue&type=script&lang=js&"
export * from "./PaginacaoLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e241123e",
  null
  
)

export default component.exports